<div class="col-lg-12 text-center mb-1">
    <img class="img-fluid" [src]="parentClubLogo()">
</div>
<!-- <div class="list-group">
    <div *ngFor="let menu of menus; let i=index">
        <a class="list-group-item list-group-item-action" aria-current="true" [routerLink]="menu.route"
            [routerLinkActive]="'active'" (click)="menuSelected(menu,i)">
            {{menu.name}}
        </a>
        <ng-container *ngIf="i==selectedMenuIndex">
            <a *ngFor="let subMenu of menu.subMenu;let subMenuI=index" class="custom-list-group-item"
                aria-current="true" [routerLink]="subMenu.route" [routerLinkActive]="'active'">{{subMenu.name}}
            </a>
        </ng-container>
    </div>
    <div class="logout" (click)="logout()">Log out</div>
</div> -->